import React, { useState } from 'react';
import { X, Mail, Lock, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AuthModal = ({ open, onClose, defaultMode = 'login' }) => {
  const [mode, setMode] = useState(defaultMode);
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      if (mode === 'login') {
        await login(form.email, form.password);
      } else {
        await register(form.email, form.password, form.name);
      }
      onClose();
      setForm({ email: '', password: '', name: '' });
    } catch (err) {
      setError(err?.response?.data?.detail || 'Etwas ist schiefgelaufen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#1a1417] border border-[#2a1f24] rounded-2xl p-7 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-[#7a6b65] hover:text-white" aria-label="Schliessen">
          <X className="w-5 h-5" />
        </button>
        <h2 className="font-serif text-2xl text-white mb-1">
          {mode === 'login' ? 'Willkommen zurück' : 'Konto erstellen'}
        </h2>
        <p className="text-sm text-[#9a8a83] mb-5">
          {mode === 'login' ? 'Melde dich mit deinem Konto an' : 'Erstelle ein kostenloses Konto'}
        </p>
        <form onSubmit={submit} className="space-y-3">
          {mode === 'register' && (
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7a6b65]" />
              <input type="text" required minLength={1} placeholder="Anzeigename"
                value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
            </div>
          )}
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7a6b65]" />
            <input type="email" required placeholder="E-Mail"
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7a6b65]" />
            <input type="password" required minLength={6} placeholder="Passwort (min. 6 Zeichen)"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-[#241a1f] border border-[#2a1f24] rounded-md pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-[#5a4d48] focus:outline-none focus:border-[#a83a5b]" />
          </div>
          {error && <p className="text-sm text-[#ff8aa3]">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full px-4 py-2.5 rounded-md bg-[#a83a5b] hover:bg-[#bf456b] disabled:opacity-60 text-white font-medium">
            {loading ? 'Bitte warten...' : (mode === 'login' ? 'Anmelden' : 'Registrieren')}
          </button>
        </form>
        <p className="text-sm text-[#9a8a83] mt-5 text-center">
          {mode === 'login' ? 'Noch kein Konto?' : 'Bereits Mitglied?'}{' '}
          <button onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}
            className="text-[#c19a8a] hover:text-white underline-offset-2 hover:underline">
            {mode === 'login' ? 'Jetzt registrieren' : 'Jetzt anmelden'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default AuthModal;
